import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "product-overview-details" }
const _hoisted_2 = { class: "product-overview-details__wrapper" }
const _hoisted_3 = { class: "product-overview-details__breadcrumbs" }
const _hoisted_4 = { class: "product-overview-details__header" }
const _hoisted_5 = { class: "product-overview-details__product-info" }
const _hoisted_6 = { class: "product-overview-details__product-name" }
const _hoisted_7 = { class: "product-overview-details__price" }
const _hoisted_8 = {
  key: 0,
  class: "product-overview-details__campaign"
}
const _hoisted_9 = { class: "product-overview-details__campaign-price" }
const _hoisted_10 = { class: "product-overview-details__campaign-name" }
const _hoisted_11 = {
  key: 0,
  class: "product-overview-details__reviews-link"
}
const _hoisted_12 = { class: "product-overview-details__colors" }
const _hoisted_13 = { class: "product-overview-details__product-color" }
const _hoisted_14 = {
  key: 1,
  class: "product-overview-details__purchase-decision-info"
}
const _hoisted_15 = { class: "product-overview-details__add-to-cart" }

import { computed, inject, onBeforeUnmount, onMounted, ref, watch } from 'vue';

import useContext from '@/composables/useContext';
import useWebsiteTexts from '@/composables/useWebsiteTexts';
import { getReviewsContext } from '@/composables/useReviews';

import ColorSelect from '../ColorSelect.vue';
import EmbeddedAddToCart from '../EmbeddedAddToCart.vue';
import FloatingAddToCart from '../FloatingAddToCart.vue';
import ReviewsLink from '../../../components/Reviews/ReviewsLink.vue';
import ProductDetailsAccordion from '../ProductDetailsAccordion/ProductDetailsAccordion.vue';
import Breadcrumbs from '@/components/Breadcrumbs.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductOverviewDetails',
  props: {
  product: {
    type: Object,
    required: true,
  },
},
  setup(__props) {



const bottomPosition = 0;

const { cart, page, formatPrice } = useContext();
const { reviewsRatingAverage, totalReviews, canDisplayReviews } =
  getReviewsContext();
const { websiteText } = useWebsiteTexts();

const addToCartContext = inject('addToCartContext') as any;

const addToCart = ref<InstanceType<typeof EmbeddedAddToCart> | null>(null);
const floatingAtc = ref<InstanceType<typeof FloatingAddToCart> | null>(null);

const isFloatingAddToCartActive = ref(false);
const isMobile = ref(false);
const isMounted = ref(false);

const floatingAtcStyle = computed(() => {
  if (isMobile.value) return {};
  return {
    bottom: `${bottomPosition}px`,
  };
});

const selectedVariant = computed(() => {
  return addToCartContext.selectedVariant.value;
});

const formattedPrice = computed(() => {
  const price = selectedVariant.value?.price;
  if (!price) return null;
  return formatPrice(price);
});

const formattedCampaignPrice = computed(() => {
  const campaignPrice = selectedVariant.value?.campaignPrice;
  if (!campaignPrice) return null;
  return formatPrice(campaignPrice);
});

const campaignName = computed(() => {
  return selectedVariant.value?.campaignName || '';
});

const purchaseDecisionInfo = computed(() => {
  return addToCartContext.purchaseDecisionInfo.value;
});

const hideAddToCartAndPrices = computed(() => {
  const ecommerceFeaturesEnabled =
    cart.value?.ecommerceFeaturesEnabled || false;
  return !ecommerceFeaturesEnabled;
});

const productBreadCrumbs = computed(() => {
  const category = page.value?.dataJson?.category;
  const product = page.value?.dataJson?.product;

  return {
    parents: [
      ...(category?.parents?.filter((p: any) => p.url && p.name) || []),
      {
        name: category?.name,
        url: category?.url,
      },
    ],
    name: product?.fields?._name,
    url: `${category?.url}/${product?.fields?._url}`,
  };
});

watch(
  () => addToCartContext.selectedVariant.value,
  () => {
    try {
      if (isMobile.value) {
        if (floatingAtc.value) {
          floatingAtc.value?.close();
        }
      }
    } catch (e) {
      console.error(e);
    }
  }
);

function updateFloatingAtc() {
  isMobile.value = window.innerWidth < 768;
  if (!addToCart.value?.$el) return;

  isFloatingAddToCartActive.value =
    addToCart.value.$el.getBoundingClientRect().bottom < 0;
  if (!isFloatingAddToCartActive.value && floatingAtc.value) {
    floatingAtc.value.close();
  }
}

onMounted(() => {
  window.addEventListener('scroll', updateFloatingAtc);
  window.addEventListener('resize', updateFloatingAtc);
  updateFloatingAtc();
  isMounted.value = true;
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', updateFloatingAtc);
  window.removeEventListener('resize', updateFloatingAtc);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(Breadcrumbs, { category: _unref(productBreadCrumbs) }, null, 8, ["category"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(__props.product.fields._name), 1)
        ]),
        (!_unref(hideAddToCartAndPrices))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["product-overview-details__price-container", {
            'product-overview-details__price-container--campaign':
              _unref(formattedCampaignPrice),
          }])
            }, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(formattedPrice)), 1),
              (_unref(formattedCampaignPrice))
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(formattedCampaignPrice)), 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(campaignName)), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      (_unref(canDisplayReviews))
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(ReviewsLink, {
              rating: _unref(reviewsRatingAverage),
              totalReviews: _unref(totalReviews)
            }, null, 8, ["rating", "totalReviews"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(websiteText)('product_overview__color').value) + ": " + _toDisplayString(__props.product.fields.Color.name), 1),
        _createVNode(ColorSelect, {
          alt: __props.product.fields._name,
          colors: __props.product.colorVariants
        }, null, 8, ["alt", "colors"])
      ]),
      (_unref(purchaseDecisionInfo))
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(purchaseDecisionInfo)), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_15, [
      (!_unref(hideAddToCartAndPrices))
        ? (_openBlock(), _createBlock(EmbeddedAddToCart, {
            key: 0,
            ref_key: "addToCart",
            ref: addToCart
          }, null, 512))
        : _createCommentVNode("", true)
    ]),
    (isMounted.value && !isMobile.value && !_unref(hideAddToCartAndPrices))
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "#fatc-teleport-target"
        }, [
          _createVNode(FloatingAddToCart, {
            ref_key: "floatingAtc",
            ref: floatingAtc,
            class: _normalizeClass(["product-overview-details__fatc", {
            'product-overview-details__fatc--active': isFloatingAddToCartActive.value,
          }]),
            style: _normalizeStyle(_unref(floatingAtcStyle))
          }, null, 8, ["style", "class"])
        ]))
      : _createCommentVNode("", true),
    (isMobile.value && !_unref(hideAddToCartAndPrices))
      ? (_openBlock(), _createBlock(FloatingAddToCart, {
          key: 1,
          ref_key: "floatingAtc",
          ref: floatingAtc,
          class: _normalizeClass(["product-overview-details__fatc", {
        'product-overview-details__fatc--active': isFloatingAddToCartActive.value,
      }]),
          style: _normalizeStyle(_unref(floatingAtcStyle))
        }, null, 8, ["style", "class"]))
      : _createCommentVNode("", true),
    _createVNode(ProductDetailsAccordion)
  ]))
}
}

})